import React from 'react';
import PropTypes from 'prop-types';
import { addSpacesAndCapitalizeAllWords } from 'Helpers/Formats';
import View from './View';

const ReadOnlyJsonObjectView = ({ jsonObject }) => {
  const recurseGetRows = (base, depth) => {
    const newRows = [];
    if (base === undefined || base === null) {
      return newRows;
    }
    for (const [key, value] of Object.entries(base)) {
      if (Array.isArray(value)) {
        newRows.push({
          left: addSpacesAndCapitalizeAllWords(key),
          right: value.length > 0 ? value : '',
        });
      } else if (value && typeof value === 'object') {
        newRows.push({ left: addSpacesAndCapitalizeAllWords(key), right: '', sectionHeader: true });
        const objectRows = recurseGetRows(value, depth + 1).map((row) => {
          const subRow = row;
          if (!subRow.tabs) {
            subRow.tabs = depth + 1;
          }
          return subRow;
        });
        newRows.push(...objectRows);
      } else {
        newRows.push({
          left: addSpacesAndCapitalizeAllWords(key),
          right: value ? value.toString() : '',
        });
      }
    }
    return newRows;
  };
  const getRows = () => recurseGetRows(jsonObject, 0);

  const rows = getRows();
  if (!jsonObject) {
    return null;
  }
  return (
    <View
      rows={rows}
    />
  );
};

ReadOnlyJsonObjectView.propTypes = {
  jsonObject: PropTypes.object.isRequired,
};

export default ReadOnlyJsonObjectView;
